<!-- @format -->
<template>
	<div>
		<van-grid :border="false" :column-num="3">
			<van-grid-item v-for="item in menus" :key="item.id" icon="photo-o" :text="item.name" @click="moToSubSystem(item)">
				<van-image :src="item.logo" />

				<div>{{ item.name }}</div>
			</van-grid-item>
		</van-grid>
	</div>
</template>

<script lang="ts" setup>
	import { MenuItem, useGlobalStoreWithOut } from '@power/runtime-vue3';
	import { moToSubSystem } from './index';
	const globalStore = useGlobalStoreWithOut();
	interface Props {
		menus?: Array<MenuItem>; // 所有菜单
	}
	const props = withDefaults(defineProps<Props>(), {});
	const menus = props.menus || globalStore.subSystems;
</script>

<style scoped lang="scss"></style>
